import React, {Fragment} from "react";
import styles from "./ContentB4.scss";
import blockStyles from "@baseStyles/block.scss";

const ContentB4 = ({data, size, color = ''}) => {

	if (!data || !Array.isArray(data)) {
		return null;
	}

	let sizeClassMap = {
		'XS': blockStyles.sizeXS,
		'S': blockStyles.sizeS,
		'M': blockStyles.sizeM,
		'L': blockStyles.sizeL,
		'XL': blockStyles.sizeXL,
		'800': blockStyles.w800,
		'640': blockStyles.w640
	}

	return (
	  <div
		className={`${styles.container} ${sizeClassMap[size] ? sizeClassMap[size] : ''} ${color ? blockStyles[color] : ''}`}>
		  {data.map((item, key) => {
			  const isLastElement = key === (data.length - 1);

			  return (
				<Fragment key={key}>
					{typeof item === 'string'
					  ?
					  <span dangerouslySetInnerHTML={{__html: item}}/>
					  :
					  <span>{item}</span>
					}
					{!isLastElement && <br/>}
				</Fragment>
			  );
		  })}
	  </div>
	)
}

export default ContentB4;